var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23894_45370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8658 49.3039C38.3009 49.3039 49.1923 38.4125 49.1923 24.9774C49.1923 11.5422 38.3009 0.650879 24.8658 0.650879C11.4306 0.650879 0.539307 11.5422 0.539307 24.9774C0.539307 38.4125 11.4306 49.3039 24.8658 49.3039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8665 47.201C37.1403 47.201 47.0902 37.2511 47.0902 24.9773C47.0902 12.7035 37.1403 2.75366 24.8665 2.75366C12.5927 2.75366 2.64282 12.7035 2.64282 24.9773C2.64282 37.2511 12.5927 47.201 24.8665 47.201Z",
    fill: "url(#paint0_linear_23894_45370)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.8662 5.6048C19.4491 5.60315 14.2431 7.70553 10.3463 11.4685C6.44951 15.2315 4.16657 20.3608 3.979 25.7747C3.979 25.5233 3.979 25.2659 3.979 25.0084C3.979 19.4639 6.18155 14.1464 10.1021 10.2259C14.0227 6.30534 19.3401 4.10278 24.8846 4.10278C30.4291 4.10278 35.7465 6.30534 39.6671 10.2259C43.5876 14.1464 45.7902 19.4639 45.7902 25.0084C45.7902 25.2659 45.7902 25.5233 45.7902 25.7747C45.6009 20.355 43.3123 15.2211 39.408 11.4574C35.5036 7.69378 30.2892 5.59514 24.8662 5.6048Z",
    fill: "#082C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3586 31.4492L19.1216 37.3903L22.1954 33.6513L19.3586 31.4492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.066 13.144C31.1724 15.1167 15.3676 21.7078 9.38065 24.2004C9.20774 24.2737 9.06149 24.3984 8.96166 24.5574C8.86182 24.7165 8.81321 24.9024 8.82238 25.09C8.83155 25.2776 8.89807 25.4578 9.01294 25.6064C9.12782 25.755 9.28552 25.8647 9.46476 25.9208L16.3464 28.0618L31.7229 18.7334C31.7325 18.7258 31.7434 18.7203 31.7551 18.717C31.7668 18.7137 31.779 18.7127 31.7911 18.7141C31.8032 18.7155 31.8148 18.7193 31.8254 18.7252C31.836 18.7312 31.8454 18.7391 31.8529 18.7487C31.8604 18.7582 31.866 18.7691 31.8693 18.7808C31.8726 18.7925 31.8736 18.8048 31.8722 18.8168C31.8708 18.8289 31.867 18.8406 31.861 18.8512C31.8551 18.8618 31.8472 18.8711 31.8376 18.8787L20.0777 30.0574L30.7366 37.8489C30.9301 37.9915 31.1566 38.0826 31.395 38.1138C31.6333 38.1451 31.8757 38.1154 32.0994 38.0276C32.3232 37.9398 32.521 37.7967 32.6744 37.6116C32.8279 37.4266 32.932 37.2058 32.9769 36.9696C33.9556 31.7167 36.4254 18.6187 37.2664 14.1151C37.2976 13.9591 37.2855 13.7976 37.2315 13.648C37.1775 13.4984 37.0835 13.3665 36.9599 13.2665C36.8362 13.1665 36.6876 13.1022 36.53 13.0806C36.3724 13.059 36.212 13.0809 36.066 13.144Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23894_45370",
    x1: 47.0902,
    y1: 24.9773,
    x2: 2.64282,
    y2: 24.9773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#24CBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23894_45370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.653,
    height: 48.653,
    fill: "white",
    transform: "translate(0.539307 0.650879)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e44a4afa731c9da9520f56a8a50d358e.svg";
export { ForwardRef as ReactComponent };